import Select, { components } from 'react-select';
import { useEffect, useRef, useState } from "react";
import {
    getTimeOffRequestList, getTimeOffRequestStatusList, updateAccountEmployeeTimeOffRequestId, deleteAccountEmployeeTimeOffRequest,
    updatePagination, updateSearchPagination, updateIsLoading, updateSorting, setDateRangeValue,updateAccountTimeOffTypeId,updateAccountTimeOffStatus,resetSelectedFiltersInState
} from "./timeoffrequestSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from "../../common/timeLiveFunction";
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';
import 'rsuite/dist/rsuite.css';
import fetchAPI from '../../common/fetchAPI';
import DatePickerRanges from '../../common/DatePickerRanges';

export const TimeOffRequestFilter = (props: any) => {
    const { t } = useTranslation();  
    const [selectedTimeOffTypes, setSelectedTimeOffTypes] = useState<{ [object: string]: any }>({ value: '00000000-0000-0000-0000-000000000000', label: 'All' });
    const [selectedOptionStatus, setSelectedOptionStatus] = useState({ label: 'All', value: 'All' });
    const currentDate = new Date();
    const [startDate, setStartDate] = useState(currentDate);
    const [endDate, setEndDate] = useState(currentDate);
    // const [startDate, setStartDate] = useState(() => {
    //     const newDate = new Date();
    //     newDate.setMonth(newDate.getMonth() - 1);
    //     return newDate;
    // });
    // const [endDate, setEndDate] = useState(() => {
    //     const newDate = new Date();
    //     newDate.setMonth(newDate.getMonth() + 1);
    //     return newDate;
    // });
    const dispatch = useAppDispatch();
    const { maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector(state => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const [TimeOffArray, SetTimeOffArray] = useState<any | ''>([]);

    const options = [
        { label: getValueFromResource('All', dispatch,t), value: 'All'},
        { label: getValueFromResource('Submitted', dispatch, t), value: 'Submitted' },
        { label: getValueFromResource('Approved', dispatch, t), value: 'Approved' },
        { label: getValueFromResource('Rejected', dispatch, t), value: 'Rejected' }
    ];
    const handleDateRangeChange = (value: any) => {
        if (value !== undefined && value !== null) {
            if (value && value[0] && value[1]) {
                const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
                const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
                setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
            } else {
                setDisplayedRange('Please Select Date Range');
            }
            setStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
            setEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
            dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
        }
    }

    const getTimeOffTypes = async () => {
        const response = await fetchAPI('api/V2/TimeOffTypes/GetTimeOffTypes', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        const formattedArray = json.map((item: any) => {
            return {
                value: item.AccountTimeOffTypeId,
                label: item.AccountTimeOffType
            };
        });
        formattedArray.unshift({ value: '00000000-0000-0000-0000-000000000000', label: 'All' });    
        SetTimeOffArray(formattedArray);
    }

    useEffect(() => {
        getTimeOffTypes();
    }, []);

    const handleResetFiltersOnClickEvent = () => {
        dispatch(resetSelectedFiltersInState());
        setSelectedTimeOffTypes({ value: '00000000-0000-0000-0000-000000000000', label: 'All' });
        dispatch(updateAccountTimeOffTypeId('00000000-0000-0000-0000-000000000000'));
        setSelectedOptionStatus({ value: 'All', label: 'All' });
        dispatch(updateAccountTimeOffStatus('All'));
        const SDate = new Date();
       // SDate.setMonth(SDate.getMonth() - 1);
        const EDate = new Date();
       // EDate.setMonth(EDate.getMonth() + 1);
        setStartDate(SDate);
        setEndDate(EDate);
        dispatch(getTimeOffRequestList());
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    const handleApplyFilterOnClickEvent = () => {
        dispatch(setDateRangeValue({ startDate: format(startDate, "yyyy-MM-dd"), endDate: format(endDate, "yyyy-MM-dd") }));
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
         dispatch(getTimeOffRequestList());
    }

    const handleChangeTimeOffType = (selectedOption: any) => {
        setSelectedTimeOffTypes(selectedOption);
        dispatch(updateAccountTimeOffTypeId(selectedOption.value));
    };

    const handleChangeStatus = (selectedOption: any) => {
        setSelectedOptionStatus(selectedOption);
        dispatch(updateAccountTimeOffStatus(selectedOption.value));
    };

    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                <div className='col-md-12'>
                    <label className="fs-7 fw-normal mb-2">
                        {getValueFromResource('Date Range',dispatch, t)}
                        </label>
                    <DateRangePicker
                        onChange={handleDateRangeChange}
                        ranges={DatePickerRanges() }
                        value={[startDate, endDate]}
                        placeholder={displayedRange}
                        character={' - '}
                        cleanable={false}
                        placement="bottomEnd"
                        format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                    >
                    </DateRangePicker>
                </div>
                <div className='row mt-6'>
                    <div className="col-md-12">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {getValueFromResource('Time Off Type',dispatch, t)}
                            </label>
                            <Select
                            value={selectedTimeOffTypes}
                            id="AccountTimeOffTypeId"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="AccountTimeOffTypeId"
                            onChange={handleChangeTimeOffType}
                            options={TimeOffArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {getValueFromResource('Approval Status',dispatch, t)}
                            </label>
                        <Select
                            value={selectedOptionStatus}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="ExpenseSheetStatusId"
                            onChange={handleChangeStatus}
                            options={options}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}                       
                             />

                    </div>
                </div>
            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                            {getValueFromResource('Apply Filter',dispatch, t)}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2"
                            data-kt-element='send'
                            onClick={handleResetFiltersOnClickEvent}
                        >{getValueFromResource('Reset Filters', dispatch, t)}
                        </button>
                        <a className={"btn btn-primary btn-sm"} onClick={handleApplyFilterOnClickEvent}>
                            <i className="bi bi-filter fs-5 me-1"></i>
                            {getValueFromResource('Apply Filters',dispatch, t)}
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

const MultiValue = ({ index, getValue, ...props }: any) => {
    const maxToShow = 0;
    const overflow = getValue()
        .slice(maxToShow)
        .map((x: any) => x.label);
    return index < maxToShow ? (
        <components.MultiValue {...props} />
    ) : index === maxToShow ? (
        <>
            <MoreSelectedBadge items={overflow} totalItemCount={props.options.length} />
        </>
    ) : null;
}

const MoreSelectedBadge = ({ items, totalItemCount }: any) => {
    const style = {
        background: "#d4eefa",
        borderRadius: "4px",
        fontSize: "12px",
        padding: "5px"
    };
    const title = items.join(", ");
    const length = items.length;
    const label = length === totalItemCount ?  `All Selected(${length})` : ` ${length} Item${length !== 1 ? "s" : ""} Selected`;
    return (
        <div style={style} title={title}>
            {label}
        </div>
    );
}